import { embeddedHost } from './host-embedded.js';
import { standaloneHost, type StandaloneOptions } from './host-standalone.js';
import type { HostProvider } from './host-state.js';

export interface HostOptions extends StandaloneOptions {
  parentOrigins: readonly string[];
}
// Document lifetime, independent of React's mounts/effects. No credentials in storage or observable state.
let provider: HostProvider | undefined;
export function HostGrantProvider(options: HostOptions): HostProvider {
  if (!provider) {
    const params = new URLSearchParams(window.location.search);
    provider =
      window.parent !== window
        ? embeddedHost(
            window,
            params.get('embedded') === 'true' ? (params.get('parentOrigin') ?? '') : '',
            options.parentOrigins,
          )
        : standaloneHost(window, options);
  }
  return provider;
}
